module.exports = __webpack_public_path__ + "static/media/profile-joe.bde39217.jpg";